import React from 'react';
import { Link } from 'react-router-dom';
import Ridgeline from '../components/Ridgeline';
import ProjectList from '../components/ProjectList';
import { EMAIL, profiles } from '../data/links';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <section className="hero">
        <Ridgeline />
        <div className="hero-content">
          <h1>Colin Stebelski</h1>
          <p className="hero-lead">
            I build software in my spare time and spend the rest of it outside.
          </p>
        </div>
      </section>

      <div className="camp">
        <section className="about" id="about">
          <div className="about-text">
            <h2>A bit about me</h2>
            <p>
              Programming is what I do with my free hours. I like building small,
              useful things that I wanted to exist, shipping them, and seeing who
              else finds them handy.
            </p>
            <p>
              Away from the keyboard I&rsquo;m usually on a trail, at a campsite,
              in the gym, or somewhere new with my family. Health, family, and
              technology are the three things I keep coming back to.
            </p>
          </div>
          <aside className="about-now">
            <h2>Right now</h2>
            <ul>
              <li>Getting Serin Radar onto Android</li>
              <li>Adding tools to Handybench</li>
              <li>Planning the next trip out</li>
            </ul>
          </aside>
        </section>

        <section className="work" id="work">
          <div className="section-heading">
            <h2>Things I&rsquo;ve built</h2>
            <Link to="/projects">More about each one</Link>
          </div>
          <ProjectList />
        </section>

        <section className="hello" id="hello">
          <h2>Say hello</h2>
          <p>
            Questions about a project, a trail recommendation, or anything else:
            email is the best way to reach me.
          </p>
          <p className="hello-links">
            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            {profiles.map((p) => (
              <a key={p.label} href={p.url} target="_blank" rel="noopener noreferrer">{p.label}</a>
            ))}
          </p>
        </section>
      </div>
    </div>
  );
};

export default Home;
